import { useHistory } from 'react-router';
import DonorComplete from './DonorComplete';

export default function DonorCompletePage() {
  const { location } = useHistory();
  const state: any = location.state;
  return <DonorComplete bankUnhookException={state.bankUnhookException} />;
}
